import { http } from './config'

export default {
    listarCST: () => {
        return http.get('/v1/cst')
    },
    listarCST_PIS_CONFIS: () => {
        return http.get('/v1/cst/pis/confis')
    },
    listarCST_IPI: () => {
        return http.get('/v1/cst/ipi')
    },
    listarCST_CSOSN: () => {
        return http.get('/v1/cst/csosn')
    }
}